var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAmeWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 37 27",
    "aria-labelledby": "ameWhiteIcon ameWhiteDesc"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.843 6.073a3.141 3.141 0 004.419 0L25.499.87a3.128 3.128 0 012.095-.9H8.527a3.194 3.194 0 012.095.9l5.22 5.204z",
    fill: "#FFF",
    opacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.155 6.073L29.918.87a3.102 3.102 0 00-2.324-.9 3.194 3.194 0 00-2.095.9l-5.237 5.204a3.141 3.141 0 01-4.42 0L10.607.87a3.128 3.128 0 00-2.095-.9 3.102 3.102 0 00-2.324.9L.949 6.073a3.073 3.073 0 000 4.387l14.878 14.795a3.141 3.141 0 004.418 0L35.123 10.46c1.244-1.195 1.244-3.175.032-4.387z",
    fill: "#FFF"
  })));
}

export default SvgAmeWhite;